import { createFileRoute } from '@tanstack/react-router';
import { Field } from '@osd/ui/field';
import { Stack } from '@osd/ui/stack';
import { Switch } from '@osd/ui/switch';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/switch — live docs for the `Switch` primitive.
 */
export const Route = createFileRoute('/ui/_layout/switch')({
  component: SwitchPage,
});

function SwitchPage() {
  return (
    <Stack gap={6}>
      <Section
        title="Switch"
        hint='toggle pill — semantically <input type="checkbox" role="switch">'
      >
        <Stack gap={3}>
          <Field label="Notifications">
            <Switch name="notif-email" label="Email" defaultChecked />
            <Switch name="notif-sms" label="SMS" />
          </Field>
          <Switch name="marketing" label="Send me product updates" />
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            title="Uncontrolled — name attr + label"
            language="tsx"
            code={`<Switch name="marketing" label="Send me product updates" />`}
          />

          <CodeBlock
            title="Default on"
            language="tsx"
            code={`<Switch
  name="notif-email"
  label="Email notifications"
  defaultChecked
/>`}
          />

          <CodeBlock
            title="Controlled"
            language="tsx"
            code={`const [enabled, setEnabled] = useState(false);
return (
  <Switch
    name="dark-mode"
    label="Dark mode"
    checked={enabled}
    onChange={(e) => setEnabled(e.target.checked)}
  />
);`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
